import { STATIC_KEYS } from 'src/app/shared/shared-config';

export class dataTable {
  'SKU': number;
  'SKU Short Descr': string;
  'Mfr': string;
  'Category': string;
  'Brand': string;
  'PT': string;
  'PS': number;
  'Ret': string;
  'Pack Segm': string;
  'SKU Group': number;
  'Channel': string;
  'Region': string;
  'Segment': string;
  'Base Price': number;
  'Next Price': number;
  'Scenario Price': number;
  'Active SKU': string;
  'Trans. Mix': number;
  'Volume(UC)': number;
  'NR_UC': number;
  'GP_UC': number;
  'PE': number;
  'Base Vol': number;
  'Tx Gained Via Switching': number;
}

export const data = {
  year_week: [
    [
      // "2022_W39",
      // "2022_W40",
      // "2022_W41",
      // "2022_W42",
      // "2022_W43",
      // "2022_W44",
      // "2022_W45",
      // "2022_W46",
      // "2022_W47",
      // "2022_W48",
      // "2022_W49",
      // "2022_W50",
      // "2022_W51",
      // "2022_W52"
    ],
    [
      // "2023_W01",
      // "2023_W02",
      // "2023_W03",
      // "2023_W04",
      // "2023_W05",
      // "2023_W06",
      // "2023_W07",
      // "2023_W08",
      // "2023_W09",
      // "2023_W10",
      // "2023_W11",
      // "2023_W12",
      // "2023_W13",
      // "2023_W14",
      // "2023_W15",
      // "2023_W16",
      // "2023_W17",
      // "2023_W18",
      // "2023_W19",
      // "2023_W20",
      // "2023_W21",
      // "2023_W22",
      // "2023_W23",
      // "2023_W24",
      // "2023_W25",
      // "2023_W26",
      // "2023_W27",
      // "2023_W28",
      // "2023_W29",
      // "2023_W30",
      // "2023_W31",
      // "2023_W32",
      // "2023_W33",
      // "2023_W34",
      // "2023_W35",
      // "2023_W36",
      // "2023_W37",
      // "2023_W38",
      // "2023_W39"
    ],
  ],
  volume: ['Previous Year Sales'],
  category: ['Pencils'],
  price_change: ['Monthly', 'Weekly'],
  KPI: [
    'Volume',
    'Volume Change',
    'Share',
    'Share Change',
    'Net Revenue',
    'Net Revenue Change',
    'Gross Margin',
    'Gross Margin Change',
  ],
  viewBy: [
    'Brand',
    'Brand Variant',
    'Brand Pack Variant',
    'Manufacturer',
    'Retailer',
  ],
};

export const mapperForOutputDataKPIs = {
  Volume: 'volume',
  'Volume Change': 'volume_change',
  Share: 'share',
  'Share Change': 'share_change',
  'Net Revenue': 'net_revenue',
  'Net Revenue Change': 'net_revenue_change',
  'Gross Margin': 'gross_margin',
  'Gross Margin Change': 'gross_margin_change',
};

export const columnNameMappingForFullDataDownload = {
  Category: 'Category',
  retailer: 'Retailer',
  Manufacturer: 'Manufacturer',
  BrandPackVariant: 'SKU Description',
  BrandHouse: 'Brand',
  'Lead Amount': 'Flavor',
  LengthBand: 'LengthBand',
  PackContents: 'PackSize',
  PriceSector: 'PriceSector',
  Period_FY24: 'Period_FY24',
  Base_Price: 'Base_Price',
  'Scenario Price': 'Scenario Price',
  'Base Volume': 'Base Volume',
  'Scenario Volume': 'Scenario Volume',
  'Vol Change(abs)': 'Vol Change(abs)',
  'Vol Change(%)': 'Vol Change(%)',
  'Base share': 'Base share',
  'Scenario share(%)': 'Scenario share(%)',
  'Share Change': 'Share Change',
  'Base Net Revenue': 'Base Net Revenue',
  'Scenario Net Revenue': 'Scenario Net Revenue',
  'Net Revenue Change(abs)': 'Net Revenue Change(abs)',
  'Net Revenue Change(%)': 'Net Revenue Change(%)',
  'Base Gross Margin': 'Base Gross Margin',
  'Scenario Gross Margin': 'Scenario Gross Margin',
  'Gross Margin Change(abs)': 'Gross Margin Change(abs)',
  'Gross Margin Change(%)': 'Gross Margin Change(%)',
  BrandVariant: 'Sub Brand',
};
